import React, { useEffect, useState } from 'react'
import { makeSideBarActive } from '../../../../utils/EllowUtils'
import SideMenu from '../../sideMenu'
import Styles from "../../styles.module.scss"
import * as CONSTANTS from '../../../../utils/CONSTANTS';
// import Headline5 from '../../../../components/headings/Headline5';
import Table from '../../../../components/table';
import { getMyContracts } from './services';
import DashboardHeader from '../../dashboardHeader';

function MyContracts() {

    const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 1)
    const loginId: string = localStorage.getItem('loginId') || ''
    const [activeContracts, setActiveContracts] = useState<[]>([])
    const [closedContracts, setClosedContracts] = useState<[]>([])
    // const [selected, setSelected] = React.useState<number>(0);

  useEffect(() => {
    getContractJobdetails('activeContract')
    getContractJobdetails('completedContracts')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // const handleSelect = (e: TabStripSelectEventArguments) => {
  //   setSelected(e.selected);    
  // };
  
  const getContractJobdetails = (status: string) => {
    
    let body = {
      "candidateId": loginId,
      "status": status
    }
    getMyContracts(body).then((response) => {
      if (response && response.status === 1) {
        switch (status) {
          case 'activeContract':
            setActiveContracts(response.data)
            localStorage.setItem("activeContracts", response.data)
            return;
          case 'completedContracts':
            setClosedContracts(response.data)
            return
        }  
      }
    })
  }

  
  const redirectToAvailability = () => {
    // setSelected(2)
  }

  return (
      <section className={Styles.dashboardWrapper}>
          
        <SideMenu menu={menu} />
      <div className={Styles.dashboardContent}>
      <DashboardHeader redirectToAvailability={redirectToAvailability} title={`My Contracts`}/>
        <div className={Styles.mycontractBox}>
          <div className={Styles.subtitle}>Active Contracts</div>
          <Table type={'contract'} data={activeContracts}/>       
          <div className={Styles.subtitle}>Completed Contracts</div>
          <Table type={'contract'} data={closedContracts}/>          
        </div>
          </div>
      </section>
  )
}

export default MyContracts